export const filterList = (text, fullList, fields) => {
  if (!text || text.length < 3) return fullList;
  const upper = text.toUpperCase();
  return fullList.filter((item) =>
    fields.some((field) =>
      String(item[field] != null ? item[field] : '').toUpperCase().includes(upper)
    )
  );
};
